import { objLength } from '../../utils/customMethods'

const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const initialState = { conversations: {} }

const generalInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_GENERAL_INFO_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'GENERAL_INFO_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_GENERAL_INFO':
      return {
        ...state,
        status: {
          get_general_info: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_GENERAL_INFO':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.chatId]: { ...action.payload.data },
        },
        status: {
          ...state.status,
          get_general_info: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'UPDATE_GENERAL_INFO': {
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.chatId]: { ...action.payload.data },
        },
        status: {
          ...state.status,
          update_general_info: {
            ...initialStatus,
            success: true,
          },
        },
      }
    }
    case 'DELETE_GENERAL_INFO': {
      const { [action.payload.chatId]: id, ...rest } = state.conversations
      return {
        ...state,
        conversations: {
          ...rest,
        },        
      }
    }

    default:
      return state
  }
}

export default generalInfoReducer
